// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Alert = require("../common/Components/Alert.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let UnifiedProfileSubpages = require("./UnifiedProfileSubpages.bs.js");
let UnifiedProfileSettingsUI = require("./UnifiedProfileSettingsUI.bs.js");
let UnifiedYourProfilePublicNotice = require("./UnifiedYourProfilePublicNotice.bs.js");
let UnifiedYourProfileSettingsQuery_graphql = require("../../__generated__/UnifiedYourProfileSettingsQuery_graphql.bs.js");

let convertVariables = UnifiedYourProfileSettingsQuery_graphql.Internal.convertVariables;

let convertResponse = UnifiedYourProfileSettingsQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = UnifiedYourProfileSettingsQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, UnifiedYourProfileSettingsQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, UnifiedYourProfileSettingsQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(UnifiedYourProfileSettingsQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(UnifiedYourProfileSettingsQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(UnifiedYourProfileSettingsQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(UnifiedYourProfileSettingsQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function UnifiedYourProfileSettings(props) {
  let data = use(undefined, undefined, undefined, undefined);
  let match = data.currentlyLoggedInAgent;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(UnifiedYourProfilePublicNotice.make, {
        showHeader: true
      }),
      match !== undefined ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h3", {
                  children: "Update your profile",
                  className: "text-2xl font-medium leading-6 text-zinc-800"
                }),
                JsxRuntime.jsx("p", {
                  children: "Choose a section to update your profile.",
                  className: "text-base text-zinc-500"
                })
              ],
              className: "space-y-2"
            }),
            JsxRuntime.jsx("div", {
              children: UnifiedProfileSubpages.yourProfilePages.map(page => JsxRuntime.jsx(UnifiedProfileSettingsUI.SettingsLink.make, {
                name: page.name,
                description: page.description,
                url: page.url
              }, page.url)),
              className: "space-y-4"
            })
          ],
          className: "space-y-6"
        }) : JsxRuntime.jsx(Alert.$$Error.make, {
          title: "We couldn't load your profile. Refresh and try again."
        })
    ],
    className: "space-y-8 rounded bg-white p-6 shadow-sm"
  });
}

let make = UnifiedYourProfileSettings;

exports.Query = Query;
exports.make = make;
/* use Not a pure module */
